import { render } from "./ApplyCashbackPage.vue?vue&type=template&id=0c99d45f&scoped=true"
import script from "./ApplyCashbackPage.vue?vue&type=script&lang=js"
export * from "./ApplyCashbackPage.vue?vue&type=script&lang=js"

import "./ApplyCashbackPage.vue?vue&type=style&index=0&id=0c99d45f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c99d45f"]])

export default __exports__